import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { BaseComponent } from '../../../base/components/base.component';
import { ClickableDirective } from '../../../shared/directives/clickable.directive';

@Component({
    selector: 'app-contact-us',
    imports: [ClickableDirective],
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  sendEmail() {
    globalThis.location.href = 'mailto:care@luminousindia.com';
  }

  constructor(private readonly location: Location) {
    super();
  }
  goBack(): void {
    this.baseUserService.back();
  }

  ngOnInit(): void {
    this.baseUserService.sessionService.startBnWatch(this.router);
  }
  ngOnDestroy(): void {
    this.baseUserService.sessionService.stopBnTimer();
  }
}
